/* ==========================================================
   כרטיסי הבאנדלים (quantity_bundle) בעיצוב "בחרו את המארז שלכם".
   ----------------------------------------------------------
   משלים את assets/claude-bundle-cards.css. לכל כרטיס:
   - התיאור מפוצל לפי "/" לרשימת וי (למשל "3₪ לכוס", "משלוח חינם").
     רק חלק ראשון שאינו מחיר (בלי ₪ / "לכוס", למשל "מספיק לחודש") נשאר
     כשורת משנה; אם אין כזה – שורת המשנה מוסתרת.
   - נוסף תג "X% הנחה" על המסגרת התחתונה של הכרטיס, מחושב מהמחיר
     בפועל ומחיר ההשוואה של הכרטיס (data-price / data-compare-price).
   - "+1 במתנה" / "+2 במתנה" שבשם המארז הופך לתג נפרד בצבע תגי ההנחה.
   - כל תג "חיסכון של ..." בתוך הכרטיס (מכל מקור – גרסה קודמת, אפליקציה
     או תרגום) מוסתר; תג "X% הנחה" שלנו הוא היחיד שמוצג.
   - צבעים שהבלוק קובע inline (תג, כותרת) מוסרים כדי שהעיצוב יחול.
   הפעולות אידמפוטנטיות ומתבצעות שוב אם הבלוק מתרנדר מחדש.
   ========================================================== */
(function () {
  'use strict';

  var CHECK_SVG =
    '<svg class="cb-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M7.5 12.5l3 3 6-6.5"/></svg>';

  function splitDescription(card) {
    var desc = card.querySelector('.quantity-bundle-description');
    if (!desc || desc.dataset.cbSplit) return;
    var parts = desc.textContent.split('/').map(function (s) { return s.trim(); }).filter(Boolean);
    desc.dataset.cbSplit = '1';
    if (!parts.length) return;
    var isPrice = /₪|לכוס/;
    var subtitle = isPrice.test(parts[0]) ? '' : parts[0];
    var items = subtitle ? parts.slice(1) : parts;
    desc.textContent = subtitle;
    if (!subtitle) desc.classList.add('cb-empty');
    if (!items.length) return;

    var list = document.createElement('ul');
    list.className = 'cb-features';
    items.forEach(function (text) {
      var li = document.createElement('li');
      li.innerHTML = CHECK_SVG;
      var span = document.createElement('span');
      span.textContent = text;
      li.appendChild(span);
      list.appendChild(li);
    });
    card.dataset.cbFeatures = list.outerHTML;
  }

  function ensureFeatures(card) {
    if (!card.dataset.cbFeatures || card.querySelector('.cb-features')) return;
    var anchor = card.querySelector('.quantity-bundle-pricing') || card.querySelector('.quantity-bundle-description');
    if (anchor) anchor.insertAdjacentHTML('afterend', card.dataset.cbFeatures);
  }

  function toNumber(value) {
    var n = parseFloat(String(value || '').replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function ensureDiscount(card) {
    if (card.querySelector('.cb-discount')) return;
    var price = toNumber(card.getAttribute('data-price'));
    var compare = toNumber(card.getAttribute('data-compare-price'));
    if (!(price > 0 && compare > price)) return;
    var pct = Math.round((1 - price / compare) * 100);
    if (pct < 1) return;
    var tag = document.createElement('span');
    tag.className = 'cb-discount';
    tag.textContent = pct + '% הנחה';
    card.appendChild(tag);
  }

  function hideOldSavings(card) {
    card.querySelectorAll('.cb-save').forEach(function (el) { el.remove(); });
    var walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT);
    var hits = [];
    while (walker.nextNode()) {
      if (/חיסכון\s*של/.test(walker.currentNode.nodeValue)) hits.push(walker.currentNode.parentElement);
    }
    hits.forEach(function (el) {
      if (!el || el.closest('.cb-discount') || el.classList.contains('quantity-bundle-card')) return;
      // לא להסתיר מיכל שמכיל גם את המחיר או את הכותרת
      if (el.querySelector('.quantity-current-price, .quantity-bundle-title, .cb-features')) return;
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function splitGift(card) {
    card.querySelectorAll('.quantity-bundle-title').forEach(function (title) {
      if (title.querySelector('.cb-gift')) return;
      var text = title.textContent;
      var match = text.match(/\+\s*\d+\s*במתנה/);
      if (!match) return;
      var name = (text.slice(0, match.index) + text.slice(match.index + match[0].length)).replace(/\s+/g, ' ').trim();
      title.textContent = name;
      var gift = document.createElement('span');
      gift.className = 'cb-gift';
      gift.textContent = match[0].replace(/\s+/g, ' ').replace(/\+\s*/, '+');
      title.appendChild(gift);
    });
  }

  // "הכי משתלם" / "הכי נמכר" – מחלקה לפי טקסט התג (לצבע מיוחד ב-CSS)
  function tagBadge(card) {
    var badge = card.querySelector('.quantity-bundle-badge');
    if (!badge) return;
    var text = badge.textContent;
    badge.classList.toggle('cb-badge-best', /משתלם/.test(text));
    badge.classList.toggle('cb-badge-popular', /נמכר/.test(text));
  }

  function clearInlineColors(card) {
    var badge = card.querySelector('.quantity-bundle-badge');
    if (badge) {
      ['background', 'color', 'border', 'box-shadow'].forEach(function (p) { badge.style.removeProperty(p); });
    }
    card.querySelectorAll('.quantity-bundle-title').forEach(function (t) { t.style.removeProperty('color'); });
  }

  function enhance(root) {
    (root || document).querySelectorAll('.quantity-bundle-card').forEach(function (card) {
      splitDescription(card);
      ensureFeatures(card);
      ensureDiscount(card);
      splitGift(card);
      hideOldSavings(card);
      clearInlineColors(card);
      tagBadge(card);
      card.classList.add('cb-ready');
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      enhance(document);
    });
  }

  function init() {
    enhance(document);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.nodeType === 3) t = t.parentElement;
        if (!t) continue;
        if (t.nodeType === 1 && t.closest && t.closest('.quantity-bundle-selector')) { schedule(); return; }
        if (t.nodeType === 1 && t.querySelector && t.querySelector('.quantity-bundle-card')) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================
   סיכום מחיר על כפתור "הוסיפי לעגלה" הראשי:
   "מארז יחיד, 179 ש״ח", ועם המנוי המסומן –
   "מארז יחיד + מנוי חודשי, 228 ש״ח". במארז עם מתנה נוסף תג זהב "🎁 +2 במתנה".
   מחיר המארז נלקח מהכרטיס הנבחר (המחיר המוצג), ומחיר המנוי מהשדה
   "מחיר המנוי בכפתור" בבלוק ה-Upsell (data-cart-price ב-claude-upsell-checkbox).
   ========================================================== */
(function () {
  'use strict';

  function num(text) {
    var m = String(text || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : 0;
  }

  function fmt(n) {
    return (Math.round(n * 100) % 100 === 0 ? String(Math.round(n)) : n.toFixed(2)) + ' ש״ח';
  }

  function selectedCard() {
    var cards = document.querySelectorAll('[id*="shop_product_details"] .quantity-bundle-card');
    for (var i = 0; i < cards.length; i++) {
      var input = cards[i].querySelector('input[type="radio"]');
      if (input && input.checked) return cards[i];
    }
    for (var j = 0; j < cards.length; j++) {
      if (cards[j].dataset.selected === 'true') return cards[j];
    }
    return null;
  }

  function cardName(card) {
    var title = card.querySelector('.quantity-bundle-title');
    if (!title) return '';
    var text = '';
    title.childNodes.forEach(function (n) { if (n.nodeType === 3) text += n.textContent; });
    return (text.trim() || title.textContent.trim()).replace(/\+\s*\d+\s*במתנה/, '').replace(/\s+/g, ' ').trim();
  }

  function update() {
    var button = document.querySelector('[id*="shop_product_details"] .shop-add-to-cart-button');
    var card = selectedCard();
    if (!button || !card) return;

    var price = num((card.querySelector('.quantity-current-price') || {}).textContent);
    // גיבוי כשהמחיר המוצג עוד לא מוכן – מעוגל לשקל כמו בכרטיסים (36999 → 370 ולא 369.99)
    if (!price && card.dataset.price) price = Math.round(Number(card.dataset.price) / 100);
    var label = cardName(card);

    document.querySelectorAll('.claude-upsell-checkbox').forEach(function (box) {
      var input = box.querySelector('.upsell-toggle-input');
      if (!input || !input.checked) return;
      price += Number(box.dataset.cartPrice) || 0;
      label += ' + ' + (box.dataset.cartLabel || 'מנוי חודשי');
    });

    var sum = button.querySelector('.cba-sum');
    if (!sum) {
      sum = document.createElement('span');
      sum.className = 'cba-sum';
      var after = button.querySelector('.button-text');
      if (after && after.nextSibling) button.insertBefore(sum, after.nextSibling);
      else button.appendChild(sum);
      button.classList.add('cba-has-sum');
    }

    // מארז עם מתנה ("+2 במתנה" בשם המארז) – תג זהב עם קופסת מתנה בשורת הסיכום
    var gift = giftCount(card);
    var key = label + '|' + gift + '|' + price;
    if (sum.dataset.key === key) return;
    sum.dataset.key = key;
    sum.textContent = '';
    var name = document.createElement('span');
    name.className = 'cba-sum-name';
    name.textContent = label;
    sum.appendChild(name);
    if (gift) {
      var pill = document.createElement('span');
      pill.className = 'cba-gift';
      var gt = document.createElement('span');
      gt.textContent = '+' + gift + ' במתנה';
      pill.appendChild(gt);
      // הקופסה אחרי הטקסט (משמאל לו ב-RTL), לא בין שם המארז ל"+2 במתנה"
      pill.insertAdjacentHTML('beforeend', GIFT_SVG);
      sum.appendChild(pill);
    }
    var p = document.createElement('span');
    p.className = 'cba-sum-price';
    p.textContent = fmt(price);
    sum.appendChild(p);
  }

  var GIFT_SVG =
    '<svg class="cba-gift-icon" viewBox="0 0 24 24" aria-hidden="true">' +
    '<rect x="4.5" y="11" width="15" height="10" rx="1.6" fill="#fff6dc"/>' +
    '<rect x="3" y="7.5" width="18" height="4.5" rx="1.4" fill="#ffffff"/>' +
    '<rect x="10.6" y="7.5" width="2.8" height="13.5" fill="#1e3524"/>' +
    '<path d="M12 7.6C10.6 4.4 7.3 3.7 6.6 5.6 6 7.3 9.2 7.8 12 7.6zM12 7.6c1.4-3.2 4.7-3.9 5.4-2 .6 1.7-2.6 2.2-5.4 2z" fill="none" stroke="#1e3524" stroke-width="1.5" stroke-linejoin="round"/>' +
    '</svg>';

  function giftCount(card) {
    var el = card.querySelector('.cb-gift');
    var text = el ? el.textContent : ((card.querySelector('.quantity-bundle-title') || {}).textContent || '');
    var m = text.match(/\+\s*(\d+)\s*במתנה/);
    return m ? m[1] : '';
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; update(); }, 30);
  }

  // באג בתבנית: כשבוחרים בעורך מארז ברירת מחדל (למשל הזוגי), הכרטיס מסומן כנבחר
  // (data-selected) אבל כפתור הרדיו של הכרטיס הראשון נשאר מסומן – ואז העגלה והכפתור
  // מקבלים את המארז הלא נכון. לחיצה על הכרטיס הנבחר מסנכרנת הכול (פעם אחת בטעינה).
  function syncDefault() {
    var cards = document.querySelectorAll('[id*="shop_product_details"] .quantity-bundle-card');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].dataset.selected !== 'true') continue;
      var radio = cards[i].querySelector('input[type="radio"]');
      if (radio && !radio.checked) cards[i].click();
      return;
    }
  }

  function init() {
    syncDefault();
    update();
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity-bundle-card, .claude-upsell-checkbox')) schedule();
    });
    // התבנית משחזרת את תוכן הכפתור אחרי הוספה, והסנכרון מול העגלה משנה את הצ'קבוקס בלי אירוע
    setInterval(update, 800);
    window.addEventListener('load', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
